export default "__VITE_ASSET__B8ldJOP6__"